<template>
  <div class="progress-bar">
    <div class="bar" :style="{ width: percent }"></div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    percent() {
      return 100 * this.progress + '%'
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  background-color: #fff;
  margin-bottom: 50px;
  position: relative;
  height: 5px;
  
  .bar {
    background-color: #35BDD1;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    transition: width 300ms;
  }
}
</style>
